import React from 'react';
import { Route, Routes } from 'react-router-dom';
import WelcomeTopic from './topics/welcome';
import Topic1100am from './topics/topic1100';
import Topic900 from './topics/topic900';
import Topic1400 from './topics/topic1400';
import TopicQuiz from './topics/topicQuiz';
import Topic1600 from './topics/topic1600';
import './index.less';
import './index.mobile.less';
import './index.en.less';

export interface IGeneralStaffProps {
  topicName: string;
  topicSettings: any;
}

export function Finance(props: IGeneralStaffProps) {
  return (
    <Routes key={props.topicName}>
      <Route
        path="/"
        element={<WelcomeTopic settings={props.topicSettings} />}
      />
      <Route
        path="/welcome"
        element={<WelcomeTopic settings={props.topicSettings} />}
      />
      <Route
        path="/900am"
        element={<Topic900 settings={props.topicSettings} />}
      />
      <Route
        path="/1100am"
        element={<Topic1100am settings={props.topicSettings} />}
      />
      <Route
        path="/200pm"
        element={<Topic1400 settings={props.topicSettings} />}
      />
      <Route
        path="/400pm"
        element={<Topic1600 settings={props.topicSettings} />}
      />
      <Route
        path="/quiz"
        element={<TopicQuiz settings={props.topicSettings} />}
      />
    </Routes>
  );
}
